export default __webpack_public_path__ + "static/media/landing-1-circle-bottom-right.90993b8b.svg";